import * as React from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { ReferenceIdContainerInterface } from '../../ReferenceIdContainer';

export interface ApplyButtonProps {
    selectedModels: ReferenceIdContainerInterface
}

/**
 * Class of buttons to apply to all the selected Job Vacancies
 */
export abstract class AbstractApplyNowButton<T extends ApplyButtonProps = ApplyButtonProps> extends React.PureComponent<T> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    constructor(props: T, context: AppContext) {
        super(props, context);
        this.handleClick = this.handleClick.bind(this);
    }

    protected getClassName(selectedModels: ReferenceIdContainerInterface) {
        return 'jc-apply-now-button primary count-' + selectedModels.length;
    }

    protected getText(selectedModels: ReferenceIdContainerInterface) {
        const count = selectedModels.length;
        if (count === 1) {
            return this.context.i18n.translate(`Auf die markierte Stelle bewerben`);
        } else {
            return this.context.i18n.translate(`Auf %d markierte Stellen bewerben`,[count]);
        }
    }

    protected getTitle(selectedModels: ReferenceIdContainerInterface) {
        const count = selectedModels.length;
        if (count === 1) {
            return this.context.i18n.translate(`Jetzt auf die markierte Stelle bewerben`);
        } else {
            return this.context.i18n.translate(`Jetzt auf %d markierte Stellen bewerben`,[count]);
        }
    }

    protected handleClick() {
        const context = this.context;
        context.applyTo(context.selectedJobVacancies);
    }
}

